import React, { useState, useEffect, useMemo, useRef } from "react";
import { Box, FormControl, FormLabel, GridItem, Input } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FormHeader } from "../../../ui/FormHeader";
import { Spinner } from "@chakra-ui/react";
import { AsyncPaginate } from "react-select-async-paginate";

import { addCategory, updateCategory, getCategoryDetailById } from "../../../redux/api/admin/collectionApi";
import { getCategoryList } from "../../../redux/reduxApi/admin/CategoryReduxApi";
import { taxOptions } from "../utils/SearchPickList";
import { getLoggedInUserId } from "../../../../utils/authUtils";
import { getUserDetails } from "../../../../utils/IndexDB/PermissionStore";
import { getEmployeesList } from "../../../redux/reduxApi/admin/EmployeesReduxApi";
import { formatDateTime } from "../../../../utils/commonFunctions";

function CategoryForm({ closeDrawer }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const categoryList = useSelector((state) => state.category.category);
  const loggedInUserId = getLoggedInUserId();
  const [userDetails, setUserDetails] = useState(null);
  const [createdByOptions, setCreatedByOptions] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [employeedAllData, setemployeedAllData] = useState([]);
   const [categoryOptions, setCategoryOptions] = useState([]);

  
  const [previewImage, setPreviewImage] = useState(null);
  const [existingImage, setExistingImage] = useState(null);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const fileInputRef = useRef(null);
  const location = useLocation();
  const isUpdateMode = location.state?.isUpdateMode;
  const cateId = location.state?.id;
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);


  useEffect(() => {
    const fetchUserDetails = async () => {
      const user = await getUserDetails();
      setUserDetails(user);
    };
    fetchUserDetails();
  }, []);

  useEffect(() => {
    dispatch(getEmployeesList({ page: 1, size: 30, limit: 30 }))
      .then((response) => {
        const employees = response.payload?.data?.employees || [];
        const options = employees.map((emp) => ({
          label: `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || emp.email || "Unknown",
          value: emp.ROWID,
        }));
        setCreatedByOptions(options);
      })
      .catch((error) => {
        console.error("Error fetching employees:", error);
      });
  }, [dispatch]);

  const loggedInUserOption = useMemo(() => {
    if (!loggedInUserId) return null;
    return {
      label: userDetails?.employeeName || "Current User",
      value: loggedInUserId,
    };
  }, [loggedInUserId, userDetails]);

    const [formData, setFormData] = useState({
    name: "",
    description: "",
    parentCategoryId: null,
    hscCode: "",
    dailyProduction: "",
    tax: null,
    createdBy: loggedInUserId ? String(loggedInUserId) : null,   
    modifiedBy: null,                                             
    createdByDetails: null,
    modifiedByDetails: null,
    CREATEDTIME: "",
    MODIFIEDTIME: "",
  });

    const selectedCreatedByOption = useMemo(() => {

      const targetCreatedBy = formData.createdBy;
      if (!targetCreatedBy) return null;

    const option = createdByOptions.find(
      (opt) => String(opt.value) === String(targetCreatedBy)
    );
    if (option) return option;

    if (formData.createdByDetails) {
      const details = formData.createdByDetails;
      const fullName = `${details.firstName || ""} ${details.lastName || ""}`.trim();
      return {
        label: fullName || details.employeeName || details.email || "Unknown",
        value: details.ROWID || targetCreatedBy,
      };
    }
    if (loggedInUserOption && String(loggedInUserOption.value) === String(targetCreatedBy)) {
      return loggedInUserOption;
    }
    if (typeof formData.createdBy === "string" && !/^\d+$/.test(formData.createdBy)) {
      return { label: formData.createdBy, value: formData.createdBy };
    }
    return null;
  }, [createdByOptions, formData.createdBy, formData.createdByDetails, loggedInUserOption]);

  const selectedModifiedByOption = useMemo(() => {
      const targetModifiedBy = formData.modifiedBy;
  
      if (targetModifiedBy) {
        const option = createdByOptions.find(
          (opt) => String(opt.value) === String(targetModifiedBy)
        );
        if (option) return option;
  
        if (loggedInUserOption && String(loggedInUserOption.value) === String(targetModifiedBy)) {
          return loggedInUserOption;
        }
  
        if (formData.modifiedByDetails) {
          const details = formData.modifiedByDetails;
          const fullName = `${details.firstName || ""} ${details.lastName || ""}`.trim();
          return {
            label: fullName || details.employeeName || details.email || "Unknown",
            value: details.ROWID || targetModifiedBy,
          };
        }
  
        if (typeof formData.modifiedBy === "string" && !/^\d+$/.test(formData.modifiedBy)) {
          return { label: formData.modifiedBy, value: formData.modifiedBy };
        }
      }
  
      if (isUpdateMode && loggedInUserOption) {
        return loggedInUserOption;
      }
  
      return null;
    }, [createdByOptions, formData.modifiedBy, formData.modifiedByDetails, isUpdateMode, loggedInUserOption]);

  const employeeLookUp = useMemo(() => {
    return employeesData?.map((item) => ({
      label: `${item.firstName || ""} ${item.lastName || ""}`.trim() || item.employeeName || item.email || "Unknown",
      value: item.ROWID,
    }));
  }, [employeesData]);

  useEffect(() => {
    if (!employeeLookUp) return;
    setemployeedAllData(employeeLookUp);
  }, [employeeLookUp]);
  
 
useEffect(() => {
  dispatch(getCategoryList({ page: currentPage, size: 30, limit: 30 }));
}, [dispatch, currentPage]);
  



  // Fetch category data for update mode
  useEffect(() => {
    if (isUpdateMode && cateId) {
      getCategoryDetailById(cateId)
        .then((response) => {
          if (response.data.status === 200) {
            const categoryData = response.data.data;

            const createdByValue =
              getEmployeeIdValue(categoryData.createdBy) ||
              loggedInUserId ||
              null;
            const modifiedByValue =
              getEmployeeIdValue(categoryData.modifiedBy) ||
              null;
            
            // Set form data
            setFormData({
              name: categoryData.name || "",
              description: categoryData.description || "",
              parentCategoryId: categoryData.parentCategoryId || null,
              hscCode: categoryData.hscCode || "",
              dailyProduction: categoryData.dailyProduction || "",
              tax: categoryData.tax || null,
              createdBy: createdByValue ? String(createdByValue) : null,
              createdByDetails:
                (typeof categoryData.createdBy === "object" ? categoryData.createdBy : null) ||
                null,
              modifiedBy: modifiedByValue ? String(modifiedByValue) : null,
              modifiedByDetails:
                (typeof categoryData.modifiedBy === "object" ? categoryData.modifiedBy : null) ||
                null,
              CREATEDTIME: categoryData.CREATEDTIME || "",
              MODIFIEDTIME: categoryData.MODIFIEDTIME || "",
            });
            
            // Handle existing image
            if (categoryData.image) {
              try {
                let imageString = categoryData.image;
                // Remove brackets if present
                if (imageString.startsWith('[') && imageString.endsWith(']')) {
                  imageString = imageString.slice(1, -1);
                }
                
                // If there are multiple images, take the first one
                const imageUrls = imageString.split(',').filter(url => url.trim() !== '');
                if (imageUrls.length > 0) {
                  setExistingImage(imageUrls[imageUrls.length-1]);
                  setPreviewImage(imageUrls[imageUrls.length-1]);
                }
              } catch (error) {
                console.error("Error parsing image:", error);
              }
            }
          } else {
            toast.error("Failed to fetch category details");
          }
        })
        .catch((error) => {
          console.log("Category fetch error:", error);
          toast.error("Error fetching category details");
        });
    }
  }, [isUpdateMode, cateId, toast, loggedInUserId]);

  // Fetch category list for parent category dropdown
  useEffect(() => {
    dispatch(getCategoryList({ page: currentPage, size: 30, limit: 30 }));
  }, [dispatch, currentPage]);

  // Prepare category options for dropdown
  useEffect(() => {
    const options = categoryList
      .filter(item => item.parentCategoryName === null && item.ROWID !== cateId)
      .map(item => ({
        label: item.name,
        value: item.ROWID,
      }));
    
    setCategoryOptions(options);
  }, [categoryList, cateId]);


    const getEmployeeIdValue = (value) => {
    if (!value) return null;
    if (typeof value === "object") {
      return value.ROWID || value.id || null;
    }
    return value;
  };


  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    // Simulate initial page load
    const timer = setTimeout(() => {
       setIsLoading((false));
    }, 500); // Adjust time as needed

    return () => clearTimeout(timer);
  }, []);

  const handleCategoryChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      parentCategoryId: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleTaxChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      tax: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // Check file size
    const maxSize = 25 * 1024 * 1024;
    const validFiles = files.filter(file => file.size <= maxSize);
    
    if (validFiles.length < files.length) {
      toast.error("Some files exceed the 25 MB limit and will not be uploaded.");
    }

    if (validFiles.length > 0) {
      setFilesToUpload(validFiles);
      // Create preview for first image
      const previewURL = URL.createObjectURL(validFiles[0]);
      setPreviewImage(previewURL);
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    setExistingImage(null);
    setFilesToUpload([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const createFormDataPayload = () => {
    const formDataObj = new FormData();
    
    console.log("Creating FormData with:", {
      name: formData.name,
      description: formData.description,
      parentCategoryId: formData.parentCategoryId,
      hscCode: formData.hscCode,
      dailyProduction: formData.dailyProduction,
      tax: formData.tax,
      isUpdateMode,
      cateId
    });
    
    // Add text fields - these names must match what backend expects
    formDataObj.append('name', formData.name);
    formDataObj.append('description', formData.description);
    formDataObj.append('hscCode', formData.hscCode || '');
    formDataObj.append('dailyProduction', formData.dailyProduction || '');
    
    // Add tax if selected
    if (formData.tax !== null && formData.tax !== undefined && formData.tax !== '') {
      formDataObj.append('tax', formData.tax);
    }
    
    // Add parent category only if it has a value
    if (formData.parentCategoryId !== null && 
        formData.parentCategoryId !== undefined && 
        formData.parentCategoryId !== '') {
      formDataObj.append('parentCategoryId', formData.parentCategoryId);
    }
    
    // Add createdBy and modifiedBy
    if (!isUpdateMode) {
      const finalCreatedBy = formData.createdBy || loggedInUserId;
      if (finalCreatedBy && /^\d+$/.test(String(finalCreatedBy))) {
        formDataObj.append('createdBy', String(finalCreatedBy));
      }
    }
    if (isUpdateMode && loggedInUserId && String(loggedInUserId).toLowerCase() !== "null" && String(loggedInUserId).toLowerCase() !== "undefined" && String(loggedInUserId) !== "") {
      formDataObj.append('modifiedBy', String(loggedInUserId));
    }
    
    // For update mode, backend needs the ROWID in the FormData
    if (isUpdateMode && cateId) {
      formDataObj.append('ROWID', cateId);
    }
    
    // Add files only if new files are uploaded
    if (filesToUpload.length > 0) {
      filesToUpload.forEach((file, index) => {
        formDataObj.append('file', file);
      });
    }
    
    // Log what's in FormData
    console.log("FormData entries:");
    for (let [key, value] of formDataObj.entries()) {
      console.log(`${key}:`, value);
    }
    
    return formDataObj;
  };

  const validateForm = () => {
    if (!formData.name || !formData.description) {
      toast.error("Name and description are required");
      return false;
    }

    // Validate HSC Code format (optional but if provided should be alphanumeric)
    if (formData.hscCode && !/^[A-Za-z0-9\s-]+$/.test(formData.hscCode)) {
      toast.error("HSC Code should contain only letters, numbers, spaces, or hyphens");
      return false;
    }

    // For create mode, we need to check if image is provided
    // if (!isUpdateMode && filesToUpload.length === 0) {
    //   toast.error("Image is required for new category");
    //   return false;
    // }

    // For update mode, check if category ID exists
    if (isUpdateMode && !cateId) {
      toast.error("Category ID is required for update");
      return false;
    }

    return true;
  };

  // Common success handler
  const handleSuccess = () => {
    // Reset form
    setFormData({
      name: "",
      description: "",
      parentCategoryId: null,
      hscCode: "",
      dailyProduction: "",
      tax: null,
    });
    setPreviewImage(null);
    setFilesToUpload([]);
    setExistingImage(null);
    
    // Refresh category list
    dispatch(getCategoryList());
    
    // Navigate back
    if (closeDrawer) {
      closeDrawer();
    } else {
      navigate("/admin/inventory/collection");
    }
  };

  // Common error handler
  const handleError = (response) => {
    const errorMsg = response.payload?.message || 
                    response.payload?.data?.message || 
                    (isUpdateMode ? "Failed to update category" : "Failed to add category");
    toast.error(errorMsg);
  };

  // SINGLE COMMON SUBMISSION FUNCTION
 const handleFormSubmit = async (e) => {
  e.preventDefault();

  if (isSubmitting) return;

  if (!validateForm()) return;

  setIsSubmitting(true);

  // Use the payload created by createFormDataPayload()
  const formDataToSend = createFormDataPayload();

  try {
    let response;

    if (isUpdateMode) {
      // Update existing category
      response = await dispatch(updateCategory({ id: cateId, data: formDataToSend })).unwrap();
      // Optionally dispatch a Redux action to update the store
      // dispatch(updateCategoryAction(response?.data?.data));
      toast.success("Category updated successfully");
    } else {
      // Create new category
      response = await dispatch(addCategory(formDataToSend)).unwrap();
      // dispatch(addCategoryAction(response?.data?.data));
      toast.success("Category created successfully");
    }

    // Refresh the category list
    dispatch(getCategoryList({ page: 1, size: 30, limit: 30 }));

    // Close drawer or navigate
    if (closeDrawer) {
      closeDrawer();
    } else {
      navigate("/admin/inventory/collection");
    }
  } catch (error) {
    console.error("Error saving category:", error);
    toast.error(error.response?.data?.message || "Error saving category");
  } finally {
    setIsSubmitting(false);
  }
};
        
          const handleOnClose = () => {
            closeDrawer();
          };

  // Find selected category for dropdown
  const selectedCategoryOption = formData.parentCategoryId 
    ? categoryOptions.find(option => option.value === formData.parentCategoryId)
    : null;

  // Find selected tax option
  const selectedTaxOption = formData.tax 
    ? taxOptions.find(option => option.value === formData.tax)
    : null;

  return (
    <Box className="h-[93vh] flex flex-col mb-32 overflow-y-auto">
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="#011638" />
        </div>
      )}

      <FormHeader 
        isUpdateMode={isUpdateMode} 
        heading={isUpdateMode ? "Category" : "Category"} 
        onUpdate={handleFormSubmit}
        onSubmit={handleFormSubmit}
        isSubmitting={isSubmitting}
      />
      
      <form>
        <div className="m-4 overflow-y-scroll">
          <div className="card mb-20">
            <div className="card-body">
              <div className="row g-3">
                {/* Left Section */}
                <div className="col-lg-8 col-md-7 col-12">
                  <div className="form-group mb-3">
                    <label htmlFor="title">Category Name <span style={{ color: "red"}}>*</span></label>
                    <input
                      className="form-control"
                      id="title"
                      placeholder="Enter Category Name"
                      type="text"
                      name="name"
                      onChange={handleOnChange}
                      value={formData.name}
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label htmlFor="description">Description <span style={{ color: "red" }}>*</span></label>
                    <textarea
                      className="form-control"
                      id="description"
                      rows="5"
                      name="description"
                      placeholder="Enter Category Description"
                      onChange={handleOnChange}
                      value={formData.description}
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  {/* HSC Code Field */}
                  <div className="form-group mb-3">
                    <label htmlFor="hscCode">HSC Code </label>
                    <input
                      className="form-control"
                      id="hscCode"
                      placeholder="Enter HSC Code (e.g., 1234-56)"
                      type="text"
                      name="hscCode"
                      onChange={handleOnChange}
                      value={formData.hscCode}
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="dailyProduction">Daily Production</label>
                    <input
                      className="form-control"
                      id="dailyProduction"
                      placeholder="Enter Daily Production (e.g., 1234-56)"
                      type="text"
                      name="dailyProduction"
                      onChange={handleOnChange}
                      value={formData.dailyProduction}
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                {/* Right Section */}
                <div className="col-lg-4 col-md-5 col-12">
                  {/* Image Upload */}
                  <div className="form-group mb-3">
                    <label htmlFor="card-title">
                      Category Image
                      {/* Category Image {!isUpdateMode && <span style={{ color: "red"}}>*</span>} */}
                    </label>
                    <div
                      style={{
                        border: "2px dashed lightgrey",
                        borderRadius: "10px",
                        width: "100%",
                        minHeight: "100px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                      }}
                    >
                      {previewImage ? (
                        <div style={{ 
                          position: "relative", 
                          width: "100%", 
                          textAlign: "center" 
                        }}>
                          <img
                            src={previewImage}
                            alt="Preview"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "150px",
                              borderRadius: "10px",
                            }}
                          />
                          <button 
                            type="button" 
                            onClick={handleRemoveImage}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              backgroundColor: "rgba(0,0,0,0.6)",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "25px",
                              height: "25px",
                              cursor: "pointer",
                            }}
                            disabled={isSubmitting}
                          >
                            ×
                          </button>
                        </div>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="main-btn"
                            style={{
                              fontWeight: "bold",
                              borderRadius: "30px",
                            }}
                            onClick={() => fileInputRef.current?.click()}
                            disabled={isSubmitting}
                          >
                            <input
                              ref={fileInputRef}
                              type="file"
                              style={{ display: "none" }}
                              accept="image/*"
                              onChange={handleFileChange}
                              disabled={isSubmitting}
                            />
                            {existingImage ? "Change Image" : "Upload Image"}
                          </button>
                          <p style={{ fontSize: "12px", color: "#666", marginTop: "5px", marginBottom:"0px" }}>
                            Max size: 5MB per file
                          </p>
                          {/* {existingImage && isUpdateMode && (
                            <p style={{ fontSize: "12px", color: "green", marginTop: "5px" }}>
                              Using existing image
                            </p>
                          )} */}
                          {/* {!isUpdateMode && (
                            <p style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                              * Required for new category
                            </p>
                          )} */}
                        </>
                      )}
                    </div>
                  </div>

                  {/* Tax Field */}
                  <div className="form-group mb-3">
                    <label htmlFor="tax">Tax Rate</label>
                    <Select
                      options={taxOptions}
                      onChange={handleTaxChange}
                      value={selectedTaxOption}
                      menuPortalTarget={document.body}
                      placeholder="Select tax rate "
                      isClearable
                      isSearchable
                      isDisabled={isSubmitting}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: "#e2e8f0",
                          "&:hover": {
                            borderColor: "#cbd5e0",
                          },
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>

                  {/* Parent Category */}
                  <div className="form-group">
                    <label htmlFor="parentCategory">Parent Category</label>
                    <Select
                      options={categoryOptions}
                      onChange={handleCategoryChange}
                      value={selectedCategoryOption}
                      menuPortalTarget={document.body}
                      placeholder="Select parent category (Optional)"
                      isClearable
                      isSearchable
                      isDisabled={isSubmitting}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: "#e2e8f0",
                          "&:hover": {
                            borderColor: "#cbd5e0",
                          },
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </div>

                {/* Created By / Modified By Row */}
                  <GridItem>
                                        <FormControl>
                                          <FormLabel htmlFor="createdBy">Created By</FormLabel>
                                          <AsyncPaginate
                                            value={selectedCreatedByOption}
                                            loadOptions={async (search) => ({
                                              options: createdByOptions.filter((option) =>
                                                option.label.toLowerCase().includes(search?.toLowerCase() || "")
                                              ),
                                            })}
                                            onChange={(selected) =>
                                              setFormData((prev) => ({
                                                ...prev,
                                                createdBy: selected ? String(selected.value) : null,
                                              }))
                                            }
                                            isDisabled={isUpdateMode}
                                            placeholder="Created By"
                                          />
                                        </FormControl>
                                      </GridItem>
              
                                      <GridItem>
                                        <FormControl>
                                          <FormLabel htmlFor="modifiedBy">Modified By</FormLabel>
                                          <AsyncPaginate
                                            value={selectedModifiedByOption}
                                            loadOptions={async (search) => ({
                                              options: createdByOptions.filter((option) =>
                                                option.label.toLowerCase().includes(search?.toLowerCase() || "")
                                              ),
                                            })}
                                            isDisabled={true}
                                            placeholder={isUpdateMode ? "Modified By" : "-"}
                                          />
                                        </FormControl>
                                      </GridItem>
              
                                      <GridItem>
                                        <FormControl>
                                          <FormLabel htmlFor="CREATEDTIME">Created Time</FormLabel>
                                          <Input
                                            type="text"
                                            className="form-control"
                                            name="CREATEDTIME"
                                            value={formatDateTime(formData.CREATEDTIME)}
                                            isReadOnly
                                            isDisabled
                                          />
                                        </FormControl>
                                      </GridItem>
              
                                      <GridItem>
                                        <FormControl>
                                          <FormLabel htmlFor="MODIFIEDTIME">Modified Time</FormLabel>
                                          <Input
                                            type="text"
                                            className="form-control"
                                            name="MODIFIEDTIME"
                                            value={formatDateTime(formData.MODIFIEDTIME)}
                                            isReadOnly
                                            isDisabled
                                          />
                                        </FormControl>
                                      </GridItem>

              </div> {/* closes row g-3 */}
            </div> {/* closes card-body */}
          </div> {/* closes card mb-20 */}
        </div> {/* closes m-4 overflow-y-scroll */}
      </form>
    </Box>
  );
}

export default CategoryForm;